import PageTitle from "@app/components/page-title.tsx";
import useUserData from "@app/data-hooks/use-user-data.ts";
import { Box, Button, TextField } from "@mui/material";
import { useForm } from "@tanstack/react-form";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

interface FormProps {
    email?: string;
}

export const Route = createFileRoute("/account/forgot-password")({
    component: Component,
});

function Component() {
    const { requestPasswordReset } = useUserData();

    const navigate = useNavigate();

    const form = useForm({
        defaultValues: {
            email: undefined,
        } as FormProps,
        onSubmit: async ({ value }) => {
            await requestPasswordReset.mutateAsync({ user_name: value.email });
            void navigate({ to: "/" });
        },
    });

    return (
        <>
            <PageTitle>Forgot Password</PageTitle>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    void form.handleSubmit();
                }}
            >
                <Box maxWidth={"sm"} margin={"0 auto"} flexDirection={"column"} display={"flex"} gap={2}>
                    <form.Field name={"email"}>
                        {(field) => (
                            <TextField
                                label={"Email"}
                                type={"email"}
                                value={field.state.value}
                                onChange={(e) => field.handleChange(e.target.value)}
                                required
                            />
                        )}
                    </form.Field>
                    <Button type={"submit"} variant={"contained"}>
                        Reset
                    </Button>
                </Box>
            </form>
        </>
    );
}
